import React from 'react';

import { LiteratureContainer } from './styled';
import { LiteratureDownloadables } from '../../components/LiteratureDownloadables/LiteratureDownloadables';
import { ModelCard } from '../../components/ModelCard/ModelCard';
import { OwnersLiteratureDocumentsData } from '../../typings/general';

export const Literature = ({
  literatureData,
  apiConfig,
  setLiteratureData
}: {
  literatureData: OwnersLiteratureDocumentsData[];
  apiConfig: string;
  setLiteratureData: (value: any) => void;
}) => {
  return (
    <LiteratureContainer>
      <ModelCard
        setLiteratureData={setLiteratureData}
      />
      <LiteratureDownloadables
        literatureData={literatureData}
        apiConfig={apiConfig}
        setLiteratureData={setLiteratureData}
      />
    </LiteratureContainer>
  );
};
